export default __webpack_public_path__ + "static/bandera-europa-e9c36e75b606695fd39017240d3977b8.svg";